import { BufferWriter, Writer } from "protobufjs";
import { IApiClient } from "../client";
import { common, entity } from "../rpc/api";
import { getToken } from "./bind_token";

export class PartnerAPI {
  constructor(readonly apiClient: IApiClient) {}

  public getAll = (): Promise<entity.IPartner[]> => {
    return new Promise<entity.IPartner[]>((resolve, reject) => {
      getToken()
        .then((token: string): Promise<Uint8Array> => {
          const req: common.Pager = new common.Pager();
          req.page = 1;
          req.offset = 100000;
          const writer: BufferWriter | Writer = Writer.create();
          return this.apiClient.postWithToken(
            "/api.PartnerService/GetAll",
            token,
            common.Pager.encode(req, writer).finish()
          );
        })
        .then((binary: Uint8Array): void => {
          const res: entity.PartnerList = entity.PartnerList.decode(binary);
          resolve(res.items);
        })
        .catch((error: Error): void => {
          reject(error);
        });
    });
  };
}



// WEBPACK FOOTER //
// ./src/infra/api/service/partner_api.ts